import { render } from "./frontPage.vue?vue&type=template&id=c2d3216c&scoped=true"
import script from "./frontPage.vue?vue&type=script&lang=js"
export * from "./frontPage.vue?vue&type=script&lang=js"

import "./frontPage.vue?vue&type=style&index=0&id=c2d3216c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2d3216c"]])

export default __exports__